var map = {
	"./bard.json": [
		7652,
		652
	],
	"./brawler.json": [
		4870,
		870
	],
	"./druid.json": [
		6709,
		709
	],
	"./guardian.json": [
		9180,
		180
	],
	"./ranger.json": [
		3478,
		478
	],
	"./rogue.json": [
		4287,
		287
	],
	"./seraph.json": [
		4458,
		458
	],
	"./sorcerer.json": [
		1382,
		382
	],
	"./warrior.json": [
		6091,
		91
	],
	"./wizard.json": [
		2936,
		936
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1186;
module.exports = webpackAsyncContext;